import { render, staticRenderFns } from "./overview-sidebar.vue?vue&type=template&id=8f0ff8dc&scoped=true&"
import script from "./overview-sidebar.vue?vue&type=script&lang=ts&"
export * from "./overview-sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./overview-sidebar.vue?vue&type=style&index=0&id=8f0ff8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0ff8dc",
  null
  
)

export default component.exports